import gql from "graphql-tag";

export default gql`
    query ($start: Int, $limit: Int, $search: String) {
        customerList (start: $start, limit: $limit, search: $search) {
            total
            customers {
                id
                name
                country
                customerId
                discount {
                    id
                    name
                }
                currency
                lastExport
                active
                productPriceList {
                    total
                }
            }
        }
    }
`;
